import { auth } from "./guards";
export default Route => {
  // 订单
  Route.group({ prefix: "/orderInsure", beforeEnter: auth }, () => {
    Route.view("/", () =>
      import(/* webpackChunkName: "orderInsure" */ "../views/orderInsure/index.vue")
    ).name("orderInsure");
    Route.view("/detail/:policyCode", () =>
      import(/* webpackChunkName: "orderInsure" */ "../views/orderInsure/detail.vue")
    ).options({
      name: "order-detail",
      props: true
    });
    Route.view("/insureApply/:policyCode", () =>
      import(/* webpackChunkName: "orderInsure" */ "../views/orderInsure/insureApply.vue")
    ).options({
      name: "insureApply",
      props: true
    });
  });
};
